import React from "react";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { ApprovalStatus } from "../../../../../components";
import { IRequest } from "../models";
import { FontFa } from "../../../../../components";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../../AppRoutes";
import { recallToolDocx } from "../export/template";
import * as docx from "docx";
import { saveAs } from "file-saver";

const columns: ColumnsType<IRequest> = [
  {
    title: "Mã yêu cầu",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Ngày tạo",
    dataIndex: "age",
    key: "age",
    render(value, record, index) {
      return getDDMMYYYFormat(record?.createdDateTime);
    },
  },
  {
    title: "Người tạo",
    dataIndex: "createdBy",
    key: "createdBy",
    render(value, record, index) {
      return record?.createdBy?.user?.displayName;
    },
  },
  {
    title: "Yêu cầu",
    dataIndex: "type",
    key: "type",
    render(value, record, index) {
      return <span className="flag warning">Thu hồi</span>;
    },
  },
  {
    title: "Phòng ban",
    dataIndex: "eDepartment",
    key: "eDepartment",
    render(value, record, index) {
      return record?.fields?.eDepartment;
    },
  },
  {
    title: "Trạng thái",
    dataIndex: "eRequestStatus",
    key: "eRequestStatus",
    render(value, record, index) {
      return <ApprovalStatus status={record?.fields?.eRequestStatus} />;
    },
  },
  {
    title: "",
    dataIndex: "Download",
    key: "Download",
    render(value, record, index) {
      return (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            const doc6 = recallToolDocx(record);

            docx.Packer.toBlob(doc6).then((blob) => {
              saveAs(
                blob,
                `Đề nghị thu hồi CCDC - ${getDDMMYYYFormat(new Date())}.docx`
              );
            });
          }}
        >
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      );
    },
  },
];

export const RequestList: React.FC<{ dataSource?: IRequest[] }> = ({
  dataSource,
}) => {
  const history = useHistory();

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      rowClassName="cursor-pointer"
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {
            
            event.stopPropagation();

            history.push(
              Routes.recallToolDetailPage.path.replace(":id", record.id)
            );
          },
        };
      }}
    />
  );
};
